import type { LaneKind } from '../components/LaneIcon';
import type { PageId } from '../store/AppContext';

export type NavEntry = { page: PageId; label: string; lane?: LaneKind };
export type NavGroup = { title: string; tone: 'blue' | 'red' | 'yellow'; items: NavEntry[] };

export const NAV_GROUPS: NavGroup[] = [
  {
    title: 'Главное',
    tone: 'blue',
    items: [
      { page: 'search', label: 'Поисковик', lane: 'search' },
      { page: 'neural', label: 'AI поиск', lane: 'ai' },
      { page: 'proxy', label: 'Прокси', lane: 'proxy' },
    ],
  },
  {
    title: 'Управление',
    tone: 'red',
    items: [
      { page: 'launch', label: 'Запуск', lane: 'launch' },
      { page: 'servers', label: 'Сервера', lane: 'servers' },
      { page: 'users', label: 'Пользователи', lane: 'users' },
    ],
  },
  {
    title: 'Отладка',
    tone: 'yellow',
    items: [
      { page: 'logs', label: 'Логи', lane: 'logs' },
      { page: 'profiles', label: 'Профили', lane: 'profiles' },
    ],
  },
];
